// Redux action constants — subset needed for mobile v1

// Root
export const CLEAR_ALL = 'CLEAR_ALL';

// Auth
export const IS_LOGGED_IN = 'IS_LOGGED_IN';
export const IS_LOGGED_OUT = 'IS_LOGGED_OUT';
export const SET_TOKEN = 'SET_TOKEN';
export const UPDATE_CREDENTIALS = 'UPDATE_CREDENTIALS';
export const SET_AUTH_CHALLENGE = 'SET_AUTH_CHALLENGE';
export const AUTO_VERIFYING_PHONE = 'AUTO_VERIFYING_PHONE';

// Session
export const SET_ACCOUNT = 'SET_ACCOUNT';
export const SET_CURRENT_ACCOUNT = 'SET_CURRENT_ACCOUNT';
export const SET_SETTINGS = 'SET_SETTINGS';
export const SET_THEME = 'SET_THEME';
// Pre-auth white-label branding derived from the host (`<subdomain>.eleplan.com`).
export const SET_WHITELABEL_OVERRIDE = 'SET_WHITELABEL_OVERRIDE';
export const UPDATE_CHAT_BADGE = 'UPDATE_CHAT_BADGE';
export const SET_LOCKED = 'SET_LOCKED';
// One-time "set up a passkey" offer after registration (ED-2799); payload { show, source } or null.
export const SET_PASSKEY_PROMPT = 'SET_PASSKEY_PROMPT';
export const SET_OAUTH_IN_PROGRESS = 'SET_OAUTH_IN_PROGRESS';
export const UPDATE_USER = 'UPDATE_USER';
export const NEW_VERSION = 'NEW_VERSION';

// Accounts
export const ADD_ACCOUNTS = 'ADD_ACCOUNTS';
export const FETCHING_ACCOUNTS = 'FETCHING_ACCOUNTS';
export const FETCHED_ACCOUNTS = 'FETCHED_ACCOUNTS';
export const SET_PRIMARY_ACCOUNT = 'SET_PRIMARY_ACCOUNT';

// User

// Projects
export const ADD_PROJECTS = 'ADD_PROJECTS';
export const ADD_PROJECT = 'ADD_PROJECT';
export const UPDATE_PROJECT = 'UPDATE_PROJECT';
export const REMOVE_PROJECT = 'REMOVE_PROJECT';
export const FETCHING_PROJECTS = 'FETCHING_PROJECTS';
export const FETCHED_PROJECTS = 'FETCHED_PROJECTS';

// Prompts / Chat
export const ADD_PROMPTS = 'ADD_PROMPTS';
export const ADD_QUERIES = 'ADD_QUERIES';
export const ADD_CONVERSATION = 'ADD_CONVERSATION';
export const SET_CONVERSATION_SUMMARY = 'SET_CONVERSATION_SUMMARY';
export const SET_ACTIVE_CONVERSATION = 'SET_ACTIVE_CONVERSATION';
export const FETCHING_PROMPTS = 'FETCHING_PROMPTS';
export const FETCHED_PROMPTS = 'FETCHED_PROMPTS';
export const FETCHING_QUERIES = 'FETCHING_QUERIES';
export const FETCHED_QUERIES = 'FETCHED_QUERIES';

// Loader
export const SHOW_LOADER = 'SHOW_LOADER';
export const HIDE_LOADER = 'HIDE_LOADER';

// Account Assistant (mirrors web SET_ACCOUNT_ASSISTANT_* constants)
export const SET_ACCOUNT_ASSISTANT_QUERIES        = 'SET_ACCOUNT_ASSISTANT_QUERIES';
export const SET_ACCOUNT_ASSISTANT_CONVERSATION   = 'SET_ACCOUNT_ASSISTANT_CONVERSATION';
export const SET_ACCOUNT_ASSISTANT_VIEW           = 'SET_ACCOUNT_ASSISTANT_VIEW';
export const SET_ACCOUNT_ASSISTANT_STREAMING_QUERY = 'SET_ACCOUNT_ASSISTANT_STREAMING_QUERY';

// Notification
export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';
export const HIDE_NOTIFICATION = 'HIDE_NOTIFICATION';

// Settings preferences
export const REMEMBER_ME = 'REMEMBER_ME';
export const UPDATE_ACCOUNT_FEATURES = 'UPDATE_ACCOUNT_FEATURES';
// What's left of a free account's chat credits, from each chat turn's done or refusal frame.
export const UPDATE_ACCOUNT_CHAT_CREDITS = 'UPDATE_ACCOUNT_CHAT_CREDITS';

// Blocks (reducers import from here to avoid require cycle with actions → index)
export const SET_BLOCKS = 'SET_BLOCKS';
export const SET_BLOCKS_LOADING = 'SET_BLOCKS_LOADING';
export const SET_SEGMENTS = 'SET_SEGMENTS';
export const SET_SEGMENTS_LOADING = 'SET_SEGMENTS_LOADING';

// Calendar
export const SET_CALENDAR_STATUS = 'SET_CALENDAR_STATUS';
export const SET_CALENDAR_EVENTS = 'SET_CALENDAR_EVENTS';
export const SET_CALENDAR_LOADING = 'SET_CALENDAR_LOADING';
export const SET_TIMELINE_EVENTS = 'SET_TIMELINE_EVENTS';
export const INVALIDATE_TIMELINE = 'INVALIDATE_TIMELINE';

// Fasten
export const SET_FASTEN_CONNECTIONS = 'SET_FASTEN_CONNECTIONS';
export const SET_FASTEN_LOADING = 'SET_FASTEN_LOADING';

// Block responses (survey pre-fill, same as web responses.list)
export const ADD_RESPONSES = 'ADD_RESPONSES';
export const FETCHING_RESPONSES = 'FETCHING_RESPONSES';
export const FETCHED_RESPONSES = 'FETCHED_RESPONSES';

// Project creation draft
export const SET_PROJECT_CREATION_DRAFT = 'SET_PROJECT_CREATION_DRAFT';
export const CLEAR_PROJECT_CREATION_DRAFT = 'CLEAR_PROJECT_CREATION_DRAFT';

// Avatar cache-busting
export const BUMP_AVATAR_REFRESH = 'BUMP_AVATAR_REFRESH';

// Medications (per-project)
export const ADD_MEDICATIONS = 'ADD_MEDICATIONS';
export const FETCHING_MEDICATIONS = 'FETCHING_MEDICATIONS';
export const FETCHED_MEDICATIONS = 'FETCHED_MEDICATIONS';

// Contacts (per-project)
export const ADD_CONTACTS = 'ADD_CONTACTS';
export const FETCHING_CONTACTS = 'FETCHING_CONTACTS';
export const FETCHED_CONTACTS = 'FETCHED_CONTACTS';

// Notes (per-project)
export const ADD_NOTES = 'ADD_NOTES';
export const FETCHING_NOTES = 'FETCHING_NOTES';
export const FETCHED_NOTES = 'FETCHED_NOTES';

// Note templates (system + account + project scope). No admin writes on mobile —
// create/update/delete live on the admin API and are web-only for v1.
export const ADD_NOTE_TEMPLATES = 'ADD_NOTE_TEMPLATES';
export const FETCHING_NOTE_TEMPLATES = 'FETCHING_NOTE_TEMPLATES';
export const FETCHED_NOTE_TEMPLATES = 'FETCHED_NOTE_TEMPLATES';

// Documents (per-project)
export const ADD_DOCUMENTS = 'ADD_DOCUMENTS';
export const FETCHING_DOCUMENTS = 'FETCHING_DOCUMENTS';
export const FETCHED_DOCUMENTS = 'FETCHED_DOCUMENTS';
// Per-project "dirty" counter — bumped on every successful upload from
// any source (DocumentsScreen, ChatScreen, EllieVoiceScreen, etc.). The
// DocumentsScreen useSelector-watches the counter and refetches when it
// changes, so docs uploaded from other surfaces show up immediately
// when the user navigates to the Documents tab — without relying on
// useIsFocused transitions, which proved unreliable on Android tab
// navigation (ED-2048).
export const DOCUMENTS_DIRTY = 'DOCUMENTS_DIRTY';

// Benefits (per-state)
export const ADD_BENEFITS = 'ADD_BENEFITS';
export const FETCHING_BENEFITS = 'FETCHING_BENEFITS';
export const FETCHED_BENEFITS = 'FETCHED_BENEFITS';

// Vault (per-project)
export const ADD_VAULT = 'ADD_VAULT';
export const FETCHING_VAULT = 'FETCHING_VAULT';
export const FETCHED_VAULT = 'FETCHED_VAULT';
export const UPDATE_VAULT_ENTRY = 'UPDATE_VAULT_ENTRY';

// Proposed Actions (per-project, Progressive Trust Model)
export const ADD_PROPOSED_ACTIONS = 'ADD_PROPOSED_ACTIONS';
export const FETCHING_PROPOSED_ACTIONS = 'FETCHING_PROPOSED_ACTIONS';
export const REVIEW_PROPOSED_ACTION = 'REVIEW_PROPOSED_ACTION';

// Messages (per-project inbox)
export const ADD_MESSAGES = 'ADD_MESSAGES';
export const FETCHING_MESSAGES = 'FETCHING_MESSAGES';
export const FETCHED_MESSAGES = 'FETCHED_MESSAGES';
export const PREPEND_MESSAGE = 'PREPEND_MESSAGE';
export const UPDATE_MESSAGE = 'UPDATE_MESSAGE';

// Reminders (per-project)
export const ADD_REMINDERS = 'ADD_REMINDERS';
export const FETCHING_REMINDERS = 'FETCHING_REMINDERS';
export const FETCHED_REMINDERS = 'FETCHED_REMINDERS';
export const PREPEND_REMINDER = 'PREPEND_REMINDER';
export const CANCEL_REMINDER = 'CANCEL_REMINDER';
export const COMPLETE_REMINDER = 'COMPLETE_REMINDER';
export const UPDATE_REMINDER = 'UPDATE_REMINDER';

// Navigation personas (onboarding + settings)
export const SET_NAV_PERSONAS = 'SET_NAV_PERSONAS';

// Weekly Briefings (per-project recap windows)
// `list` is a per-project array of summary rows (no briefing_json) returned by
// /briefings/list. `detail` is a per-briefing-id full row (includes briefing_json)
// fetched lazily when the user opens a specific window.
export const SET_BRIEFINGS_LIST          = 'SET_BRIEFINGS_LIST';
export const SET_BRIEFING_DETAIL         = 'SET_BRIEFING_DETAIL';
export const SET_BRIEFINGS_LOADING       = 'SET_BRIEFINGS_LOADING';
export const SET_BRIEFINGS_ERROR         = 'SET_BRIEFINGS_ERROR';
export const SET_BRIEFING_GENERATING     = 'SET_BRIEFING_GENERATING';

// Snapshots (Portable Health Snapshots)
export const SET_SNAPSHOT_VERSIONS       = 'SET_SNAPSHOT_VERSIONS';
export const SET_SNAPSHOT_SYNCING        = 'SET_SNAPSHOT_SYNCING';
export const SET_SNAPSHOT_LAST_BACKUP    = 'SET_SNAPSHOT_LAST_BACKUP';
export const SET_SNAPSHOT_ERROR          = 'SET_SNAPSHOT_ERROR';
export const SET_SNAPSHOT_BACKUP_STATUS  = 'SET_SNAPSHOT_BACKUP_STATUS';
export const SET_SNAPSHOT_VIEW_MODE      = 'SET_SNAPSHOT_VIEW_MODE';
export const CLEAR_SNAPSHOT_VIEW_MODE    = 'CLEAR_SNAPSHOT_VIEW_MODE';
export const SET_SNAPSHOT_SHARES         = 'SET_SNAPSHOT_SHARES';
export const REMOVE_SNAPSHOT_SHARE       = 'REMOVE_SNAPSHOT_SHARE';

// Partners portal
export const SET_PARTNER                 = 'SET_PARTNER';
export const SET_PARTNER_FETCHING        = 'SET_PARTNER_FETCHING';
export const SET_PARTNER_CUSTOMERS       = 'SET_PARTNER_CUSTOMERS';
export const SET_PARTNER_PROJECTS        = 'SET_PARTNER_PROJECTS';
export const SET_PARTNER_INVITES         = 'SET_PARTNER_INVITES';
export const UPSERT_PARTNER_INVITE       = 'UPSERT_PARTNER_INVITE';
export const SET_PARTNER_POPULATION      = 'SET_PARTNER_POPULATION';

// Feature flags (GLOBAL platform kill-switches; one level above account.features)
export const SET_FEATURE_FLAGS           = 'SET_FEATURE_FLAGS';
export const SET_FEATURE_FLAGS_LOADING   = 'SET_FEATURE_FLAGS_LOADING';

// Per-plan feature modules (L3; between account_features and per-member
// permissions). Keyed by project id — a member can hold several plans open
// and each has its own module map.
export const SET_PLAN_MODULES            = 'SET_PLAN_MODULES';
export const SET_PLAN_MODULES_LOADING    = 'SET_PLAN_MODULES_LOADING';
export const SET_PLAN_MODULE_PENDING     = 'SET_PLAN_MODULE_PENDING';
